<template>
    <TemplatesSitesArchived :pathId="pathId" />
</template>

<script setup>
    const route = useRoute();
    const pathId = route.params.site[0];
    definePageMeta({ layout: 'archives' });
</script>
